<div class="card">
    <p-table #dt [value]="searchResults" [columns]="cols" responsiveLayout="scroll" [rows]="90" [paginator]="true"
    [rowsPerPageOptions]="[30,60,90]" [showCurrentPageReport]="true" scrollHeight="800px" [tableStyle]="{ 'min-width': '950px' }"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [(selection)]="selectedResults"
    selectionMode="multiple" [rowHover]="true" *ngIf="searchResults" (sortFunction)="customSort($event)" [customSort]="true">
    <ng-template pTemplate="emptymessage">
        <p class="flex align-items-center justify-content-center p-3 text-lg font-medium no-results-message">No Results Available</p>
    </ng-template>
    <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between py-3">
            <span class="text-lg text-500">Search Results</span>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr class="sticky-header">
            <th></th>
            <th pSortableColumn="backlinks"[colSpan]="numOfTargets"><strong>Backlinks</strong></th>
            <th pSortableColumn="rank"  [colSpan]="numOfTargets"><strong>Rank</strong></th>
            <th pSortableColumn="firstSeen" [colSpan]="numOfTargets"><strong>First Seen</strong></th>
        </tr>
        <tr>
            <th *ngFor="let col of cols; index as i;" [pSortableColumn]="(i).toString()+'|'">{{col.header}}</th>
            <th *ngFor="let i of [].constructor(numOfTargets); let index = index"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-result>
        <!-- <pre>{{ result.domainIntersection?.[0]['1'] | json }}</pre> -->
        <ng-container *ngIf="source === 'domain-research'; else otherSource">
            <tr (click)="onSelectedBacklinkClicked(result)">
            <td style="width:30%;"><span class="p-column-title">{{'components.linkIntersectResults.referringDomainHeader' | translate}}</span>
                <a [href]="'https://'+result.domainIntersection?.[0]['1']?.target" target="_blank">
                {{result.domainIntersection?.[0]['1']?.target}}
                </a>
            </td>
            <td style="width:11.666%;" *ngFor="let key of getIntersectKeys(result.domainIntersection?.[0])">
                {{result.domainIntersection?.[0][key]?.backlinks | number:'1.0':'en-US'}}
            </td>
            <td style="width:11.666%;" *ngFor="let key of getIntersectKeys(result.domainIntersection?.[0])">
                {{result.domainIntersection?.[0][key]?.rank | number:'1.0':'en-US'}}
            </td>
            <td style="width:11.666%;" *ngFor="let key of getIntersectKeys(result.domainIntersection?.[0])">
                {{result.domainIntersection?.[0][key]?.firstSeen | date: 'short'}}
            </td>
            </tr>
        </ng-container>
        <ng-template #otherSource>
            <tr (click)="onSelectedBacklinkClicked(result)">
                <td style="width:30%;"><span class="p-column-title">{{'components.linkIntersectResults.referringDomainHeader' | translate}}</span>
                    <a [href]="'https://'+result?.domainIntersection['1']?.target" target="_blank">
                        {{result?.domainIntersection['1']?.target}}
                    </a>
                    </td>
                    <td style="width:11.666%;" *ngFor="let key of getIntersectKeys(result?.domainIntersection)">
                        {{result.domainIntersection[key]?.backlinks | number:'1.0':'en-US'}}
                    </td>
                    <td style="width:11.666%;" *ngFor="let key of getIntersectKeys(result?.domainIntersection)">
                        {{result.domainIntersection[key]?.rank | number:'1.0':'en-US'}}
                    </td>
                    <td style="width:11.666%;" *ngFor="let key of getIntersectKeys(result?.domainIntersection)">
                        {{result.domainIntersection[key]?.firstSeen | date: 'short'}}
                    </td>

            </tr>
        </ng-template>
    </ng-template>
</p-table>
</div>
